/*
Sohel  12/21/2022 3075154998 Added Record Format Fields Screen
Sohel  12/22/2022 3075154998 Integrated Record Format Fields API
Sohel 12/27/2022 3075154998 record Format Fields Added validation
Sohel 12/27/2022 3075154998 fixed Deleted Fields Issue
Sohel 12/29/2022 3075154998 Form Changes.
Sohel 01/04/2022 3075154998 removed format validation.
Sai maheshwar 01/06/2023 2701334326 added function lookup
Sohel 01/07/2022 3075154998 removed format validation.
Suresh Peddavoora 01/09/2023 2701315830 Added ClassNames for Table Data Width
Sohel 01/09/2023 2701334326 fixed fields delete issue.
Sohel 01/10/2023 2698964415 Added disable conditions.
Sai maheshwar 01/11/2023 2701326866, 2699389646 fixed value bug for function
Suresh Peddavoora 01/11/2023 2701315830 Table Data Spacing Alignments
Suresh Peddavoora 01/12/2023 2701315830 Field Name Text field Alignments
sai krishna 01/12/2023 2701334326 fixed delete popup fieldname issue .
Dilip 01/12/2023 2701315830 added field name in delete popup
Suresh Peddavoora 01/13/2023 2701315830 Fixed Text field validation Issue
// Sai Maheshwar 01/13/2023 2699714747 fixed validation issue.
Suresh Peddavoora 01/14/2023 2701315830 Added Classname for Text field Alignment Issue
//Sohel 01/19/2023 2698964415 hide position field and conditional validation
Sohel 01/19/2023 2698964415 fixed dialog box title issue
Sohel 01/23/2023 2698964415 Added Audit Fields
Sai Maheshwar 01/27/2023 2699714747, 2701334326, 2817617043 added value field for CONSTANT function.
kavyareddy 01/27/2023 3075154998 Fixed dataType issue in selectedFields
Ravi 01/27/2023 2698964415 fixed tooltip issue
Sohel 01/30/2023 2698964415 Added Format Field
Sohel 02/07/2023 2698964415 Fixed disabled Issue and Changed Function Dropdown
Sohel 02/17/2023 2701335619 fixed Function Date Format Issue
Sohel 02/20/2023 2701335619 Function Date Format Changes
Guru Prasad 02/20/2023 2701335619 Date Format Styles added
Suresh Peddavoora 2701335619 02-20-2023 Textfield alignments fixed
Ravi 2701335619 02/21/2023 Added underScore  click on space
Sohel 02/03/2023 2701335619 header line changes
Dilip 03/08/2023 2701335619 disabled field position based on condition
Sohel 03/16/2023 2701335619  Added TransForm Field in Fields Tab
Sohel 03/24/2023 2701335619 Added Logic Field in Fields
Sohel 04/14/2023 2701335619 Added Map Field Fields FOr Exception Type
Sohel 04/19/2023 2698964415 Added Data Calculation Field
Ravi 05/31/2023 2701335619  changed delete popup message
Ravi 05/31/2023 2701335619  changed delete popup message
Sohel 06/03/2023 2701334326 Added Amount Format Field
Akhila 06/12/2023 2701335619 added role access
Sohel 06/19/2023 2701335619 change Temp Repo and Function repository name
Sohel 09/20/2023 5152729159 removed Disabled Condition From Format
*/
import React, {useRef, useState} from 'react';
import {getIn} from 'formik';
import {Tooltip, IconButton, TextField, FormControl, Select, MenuItem} from '@material-ui/core';
import {DeleteOutlined} from '@material-ui/icons';
import {withField} from './withField';
import {useSelector} from 'react-redux';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import {ErrorTooltip} from '../../../../../../components/Tooltips';
import {NumberFormatter} from '../../../../../../components/UserDefinedForm/AppTextInputComponents';
import {upperCaseCode} from '../../../../../../components/UpperCaseCode';
export const showValue = (current) =>
  current.mapFieldType === 'Function' &&
  current.fieldNames &&
  ['FIXED_TEXT', 'DATE', 'TIME', 'DATE_TIME', 'CONSTANT'].includes(current.fieldNames);

function RecordFormatFields(props) {
  const {
    name,
    setFieldValue,
    errors,
    touched,
    value: current,
    index,
    values,
    key,
    dmArrayHelpers,
    deletedIds,
    setDeletedIds,
    functionsList,
    type,
    dmTempRecordAccess,
    editExisting,
  } = props;
  const dataTypes = ['Number', 'Text', 'Email', 'Amount', 'SSN', 'Phone', 'Date'];
  const [isDelete, setIsDelete] = useState(false);
  const {fixedLength, dmFormatsData, headerLines, basicInfoData, translationData} = useSelector(
    ({dataManagerRecord}) => dataManagerRecord,
  );
  const codeRef = useRef();
  const {recordType} = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const handleConfirmDelete = () => {
    dmArrayHelpers.current.remove(index);

    const ids = [
      ...deletedIds,
      values?.selectedFields[index]?.dataManagerRecordFieldId ?
        values?.selectedFields[index]?.dataManagerRecordFieldId :
        0,
    ];
    setDeletedIds(ids);
    handleClose();
  };
  const handleClose = () => {
    setIsDelete(false);
  };

  const currFunctionDataType = functionsList.filter((el) => el.value === current.fieldNames)[0]
    ?.dataType;
  const fieldFormatOptions =
    current.mapFieldType === 'Function' && ['DATE']?.includes(current.fieldNames) ?
      dmFormatsData && dmFormatsData[currFunctionDataType] :
      (dmFormatsData && dmFormatsData[current?.dataType]) || [];
  const currentFieldError = (currFieldName) =>
    getIn(touched, name + '.' + currFieldName) ? getIn(errors, name + '.' + currFieldName) : '';
  const isFieldDisabled = current.isEditable === false && recordType?.value !== 'Exception';
  const functionFieldNames = functionsList?.filter((el) => {
    return !['BYPASSREC', 'BYPASS'].includes(el.value);
  });
  return (
    <>
      <tr key={key}>
        <td className="recFormat-col recFormat-center">
          <Tooltip title="Delete">
            <IconButton
              onClick={() => setIsDelete(true)}
              disabled={isFieldDisabled || (editExisting && !dmTempRecordAccess?.edit)}
            >
              <DeleteOutlined />
            </IconButton>
          </Tooltip>
        </td>

        <td className="recFormat-col global-field-textfields">{current.mapFieldType}</td>
        {headerLines?.toString() === '0' && type === 'Import' ? (
          ''
        ) : (
          <td className="recFormat-col global-field-textfields header-field">
            <ErrorTooltip
              title={
                currentFieldError('fieldHeader')?.length > 0 ? currentFieldError('fieldHeader') : ''
              }
            >
              <TextField
                margin="dense"
                type="text"
                variant="outlined"
                placeholder={`Enter Field Header`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.fieldHeader'}
                disabled={isFieldDisabled}
                value={current.fieldHeader}
                error={currentFieldError('fieldHeader')}
                onChange={(e) => {
                  setFieldValue(name + '.fieldHeader', e.target.value);
                }}
              />
            </ErrorTooltip>
          </td>
        )}
        {fixedLength !== 'Y' && basicInfoData.dynamic !== 'Y' && (
          <td className="recFormat-col global-field-textfields position-field">
            <ErrorTooltip
              title={
                currentFieldError('fieldPosition')?.length > 0 ?
                  currentFieldError('fieldPosition') :
                  ''
              }
            >
              <TextField
                margin="dense"
                type="number"
                inputProps={{min: 1}}
                variant="outlined"
                placeholder={`Enter Field Position`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.fieldPosition'}
                disabled={isFieldDisabled}
                value={current.fieldPosition}
                error={currentFieldError('fieldPosition')}
                onChange={(e) => {
                  setFieldValue(name + '.fieldPosition', e.target.value);
                }}
              />
            </ErrorTooltip>
          </td>
        )}

        <td className="recFormat-col global-field-textfields">{current.repositoryName}</td>
        <td className="recFormat-col global-field-textfields recFormat-value-field">
          {current.mapFieldType === 'Temp Field' && (
            <ErrorTooltip
              title={
                currentFieldError('fieldNames')?.length > 0 ? currentFieldError('fieldNames') : ''
              }
            >
              <TextField
                margin="dense"
                type="text"
                variant="outlined"
                disabled={isFieldDisabled}
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.fieldNames'}
                error={currentFieldError('fieldNames')}
                value={current.fieldNames?.replaceAll(' ', '_')}
                inputRef={codeRef}
                onChange={(e) => {
                  const value = upperCaseCode(codeRef);
                  setFieldValue(name + '.fieldNames', value?.replaceAll(' ', '_'));
                }}
              />
            </ErrorTooltip>
          )}
          {(current.mapFieldType === 'DB Field' ||
            current.mapFieldType === 'Record Field' ||
            current.mapFieldType === 'Audit Field' ||
            current.mapFieldType === 'Data Calculation Field') &&
            current.fieldName}
          {current.mapFieldType === 'Function' && (
            <ErrorTooltip
              title={
                currentFieldError('fieldNames')?.length > 0 ? currentFieldError('fieldNames') : ''
              }
            >
              <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
                <Select
                  fullWidth
                  name={name + '.fieldNames'}
                  className="select-gender"
                  value={current.fieldNames}
                  disabled={isFieldDisabled}
                  placeholder="Function"
                  error={currentFieldError('fieldNames')}
                  onChange={(e) => {
                    setFieldValue(name + '.fieldNames', e.target.value);
                  }}
                >
                  <MenuItem value="none" key="none" disabled>
                    <span className="defaultSelected">Select Any</span>
                  </MenuItem>
                  {functionFieldNames?.map((sep) => (
                    <MenuItem value={sep.value} key={sep.value}>
                      {sep.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ErrorTooltip>
          )}
        </td>
        <td className="recFormat-col global-field-textfields export-dateField recFormat-value-field">
          {current.mapFieldType === 'Temp Field' ||
          current.mapFieldType === 'DB Field' ||
          current.mapFieldType === 'Record Field' ||
          current.mapFieldType === 'Audit Field' ||
          current.mapFieldType === 'Data Calculation Field' ? (
              '-'
            ) : showValue(current) && current.fieldNames === 'DATE' ? (
              <ErrorTooltip
                title={
                  currentFieldError('fieldValue')?.length > 0 ? currentFieldError('fieldValue') : ''
                }
              >
                <TextField
                  className="value-textfield"
                  margin="dense"
                  type="text"
                  variant="outlined"
                  placeholder={`Value`}
                  disabled={isFieldDisabled}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={currentFieldError('fieldValue')}
                  name={name + '.fieldValue'}
                  value={current.fieldValue}
                  InputProps={{
                    startAdornment: (
                      <Select
                        name={name + '.dateType'}
                        className="select-gender"
                        value={current.dateType}
                        disabled={isFieldDisabled}
                        onChange={(e) => {
                          setFieldValue(name + '.dateType', e.target.value);
                        }}
                      >
                        {['T + ', 'T - '].map((sep) => (
                          <MenuItem value={sep} key={sep}>
                            {sep}
                          </MenuItem>
                        ))}
                      </Select>
                    ),
                    inputComponent: NumberFormatter,
                  }}
                  onChange={(e) => {
                    setFieldValue(name + '.fieldValue', e.target.value);
                  }}
                />
              </ErrorTooltip>
            ) : showValue(current) && current.fieldNames !== 'DATE' ? (
              <ErrorTooltip
                title={
                  currentFieldError('fieldValue')?.length > 0 ? currentFieldError('fieldValue') : ''
                }
              >
                <TextField
                  margin="dense"
                  type="text"
                  variant="outlined"
                  placeholder={`Value`}
                  disabled={isFieldDisabled}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={currentFieldError('fieldValue')}
                  name={name + '.fieldValue'}
                  value={current.fieldValue}
                  onChange={(e) => {
                    setFieldValue(name + '.fieldValue', e.target.value);
                  }}
                />
              </ErrorTooltip>
            ) : (
              '-'
            )}
        </td>
        <td className="recFormat-col global-field-textfields">
          {current.mapFieldType === 'Temp Field' && (
            <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
              <Select
                fullWidth
                name={name + '.dataType'}
                className="select-gender"
                value={current.dataType}
                disabled={isFieldDisabled}
                placeholder="Data Type"
                onChange={(e) => {
                  setFieldValue(name + '.dataType', e.target.value);
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected">Select Any</span>
                </MenuItem>
                {dataTypes.map((sep) => (
                  <MenuItem value={sep} key={sep}>
                    {sep}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {(current.mapFieldType === 'DB Field' ||
            current.mapFieldType === 'Audit Field' ||
            current.mapFieldType === 'Record Field' ||
            current.mapFieldType === 'Data Calculation Field') &&
            current.dataType}
          {current.mapFieldType === 'Function' && currFunctionDataType}
        </td>
        {fixedLength !== 'N' && (
          <td className="recFormat-col global-field-textfields position-field">
            <ErrorTooltip
              title={
                fixedLength !== 'N' && currentFieldError('startPosition')?.length > 0 ?
                  currentFieldError('startPosition') :
                  ''
              }
            >
              <TextField
                margin="dense"
                type="number"
                inputProps={{min: 1}}
                variant="outlined"
                placeholder={`Enter Start Position`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.startPosition'}
                disabled={isFieldDisabled}
                value={current.startPosition}
                error={currentFieldError('startPosition')}
                onChange={(e) => {
                  setFieldValue(name + '.startPosition', e.target.value);
                }}
              />
            </ErrorTooltip>
          </td>
        )}
        {fixedLength !== 'N' && (
          <td className="recFormat-col global-field-textfields position-field">
            <ErrorTooltip
              title={
                fixedLength !== 'N' && currentFieldError('fieldLength')?.length > 0 ?
                  currentFieldError('fieldLength') :
                  ''
              }
            >
              <TextField
                margin="dense"
                type="number"
                inputProps={{min: 1}}
                variant="outlined"
                placeholder={`Enter Field Length`}
                disabled={isFieldDisabled}
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.fieldLength'}
                value={current.fieldLength}
                error={currentFieldError('fieldLength')}
                onChange={(e) => {
                  setFieldValue(name + '.fieldLength', e.target.value);
                }}
              />
            </ErrorTooltip>
          </td>
        )}

        <td className="recFormat-col global-field-textfields">
          {current.mapFieldType === 'Temp Field' ||
          current.mapFieldType === 'DB Field' ||
          current.mapFieldType === 'Record Field' ||
          current.mapFieldType === 'Audit Field' ||
          current.mapFieldType === 'Data Calculation Field' ||
          (current.mapFieldType === 'Function' && ['DATE']?.includes(current?.fieldNames)) ? (
              <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
                <Select
                  fullWidth
                  name={name + '.format'}
                  className="select-gender"
                  value={current.format}
                  placeholder="Format"
                  onChange={(e) => {
                    setFieldValue(name + '.format', e.target.value);
                  }}
                >
                  <MenuItem value="none" key="none">
                    <span className="defaultSelected">Select Any</span>
                  </MenuItem>
                  {fieldFormatOptions?.map((sep) => (
                    <MenuItem value={sep} key={sep}>
                      {sep}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              '-'
            )}
        </td>
        <td className="recFormat-col global-field-textfields">
          <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
            <Select
              fullWidth
              name={name + '.amountType'}
              className="select-gender"
              value={current.amountType}
              disabled={current.dataType !== 'Amount'}
              placeholder="Amount Format"
              defaultValue={current.dataType === 'Amount' ? 'With $' : 'none'}
              onChange={(e) => {
                setFieldValue(name + '.amountType', e.target.value);
              }}
            >
              <MenuItem value={'none'} key="none" disabled>
                <span className="defaultSelected">Select Any</span>
              </MenuItem>
              {dmFormatsData?.AMOUNT_TYPE?.map((sep) => (
                <MenuItem value={sep?.value} key={sep?.value}>
                  {sep?.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </td>
        <td className="recFormat-col global-field-textfields">
          <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
            <Select
              fullWidth
              name={name + '.transform'}
              className="select-gender"
              value={current.transform}
              placeholder="Transform"
              onChange={(e) => {
                setFieldValue(name + '.transform', e.target.value);
              }}
            >
              <MenuItem value="none" key="none">
                <span className="defaultSelected">Select Any</span>
              </MenuItem>
              {translationData?.map((sep) => (
                <MenuItem value={sep?.code} key={sep?.code}>
                  {sep?.code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </td>
      </tr>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Field"
        value={`Are you sure you want to delete the ${
          current.fieldName || current.fieldNames
        } Field?`}
        handleSubmit={handleConfirmDelete}
      />
    </>
  );
}
export default withField(RecordFormatFields);
